export const grid = {
  columnCount: 12,
  gap: {
    min: 8,
    max: 20,
  },
}
